import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CriticalPreloadingStrategy implements PreloadingStrategy {
  private criticalRoutes = ['/p', '/presubscriptions'];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Précharger les routes critiques
    if (
      route.path &&
      this.criticalRoutes.some(
        (criticalRoute) =>
          route.path === criticalRoute ||
          route.path?.startsWith(criticalRoute + '/'),
      )
    ) {
      return load();
    }

    // Ne pas précharger les autres routes
    return of(null);
  }
}
